import { rolePermissionsBusiness } from "api/bussiness/user-role-permission/role-permission-bussiness";
import { GetRoles } from "api/models/request/user-role/roles";
import { Pagination } from "api/models/response/pagination";
import { applySnapshot, flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import {
  IPermissionCollectionProperties,
  PermissionCollection,
} from "mobx-stores/_models/user-roles/permission";
import { IRoleProperties, Role } from "mobx-stores/_models/user-roles/role";
import { PaginationStore } from "./common/pagination-store";

export const RolePermissionManagement = types
  .model({
    roles: types.optional(types.array(Role), []),
    pagination: types.optional(PaginationStore, {}),
    roleSelected: types.maybeNull(Role),
    permissionCollection: types.maybeNull(PermissionCollection),
    openNew: false,
    openEdit: false,
    openDelete: false,
    openAssignPermissions: false,
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    getRoles: flow(function* getRoles(request: GetRoles) {
      try {
        self._rootStore.setProp("inProgress", true);
        const userRes = (yield rolePermissionsBusiness.getRoles(
          request
        )) as Pagination<IRoleProperties>;
        self.setProp("roles", userRes.items);
        self.pagination.setProp("totalItems", userRes.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getPermissionCollectionByRoleName: flow(
      function* getPermissionCollectionByRoleName(roleName: string) {
        try {
          self._rootStore.setProp("inProgress", true);
          const permissionRes =
            (yield rolePermissionsBusiness.getPermissionsByRoleName(
              roleName
            )) as IPermissionCollectionProperties;
          self.setProp("permissionCollection", permissionRes);
        } catch (ex) {
          console.error(ex);
        } finally {
          self._rootStore.setProp("inProgress", false);
        }
      }
    ),
  }))
  .actions((self) => ({
    replaceRole: (replaceRole: IRoleProperties) => {
      const roleNeedUpdate = self.roles.filter(
        (x) => x.id === replaceRole.id
      )?.[0];
      applySnapshot(roleNeedUpdate, replaceRole);
    },
    getFlatPermissions: () => {
      if (!self.permissionCollection?.groups) return;
      const flattenPermissions = self.permissionCollection?.groups.flatMap(
        (x) => x.permissions
      );
      return flattenPermissions;
    },
  }));
